export enum WithdrawProvider {
    GBPAY = 'gbpay',
    ECHELONPAY = 'echelon',
    PAYABL = 'payabl',
    WALLETTEC = 'wallettec',
    MONETIX = 'monetix',
    SAFECHARGE = 'safecharge',
    SKRILL = 'skrill',
    AWEPAY = 'awepay',
    ZOTAPAY = 'zotapay',
    UNIPAYMENT = 'unipayment',
    LIMEPAY = 'limepay',
    B2BINPAY = 'b2binpay',
    BVNK = 'bvnk',
}
